// Products carousel
const productCarousels = document.querySelectorAll('.Footer_Products_Carousel');

productCarousels.forEach((carousel) => {
    const nav = carousel.parentElement.querySelector('.Footer_Products_Navigation');
    const products = Array.from(carousel.querySelectorAll('.Footer_Product_Thumbnail'));
    nav.querySelector(".Right").addEventListener('click', nextProduct);
    nav.querySelector(".Left").addEventListener('click', prevProduct);

    let id = 0;
    let inCd = false;

    function nextProduct(){
        if(inCd) return;
        inCd = true;
        const prevProduct = products[id];
        id++;
        if(id >= products.length){
            id = 0;
        }
        const product = products[id];

        carousel.classList.remove('Prev');
        carousel.classList.add('Next');
        setTimeout(()=>{
            changeProduct(prevProduct, product);
        },1);
    }

    function prevProduct(){
        if(inCd) return;
        inCd = true;
        const prevProduct = products[id];
        id--;
        if(id < 0){
            id = products.length - 1;
        }
        const product = products[id];

        carousel.classList.remove('Next');
        carousel.classList.add('Prev');
        setTimeout(()=>{
            changeProduct(prevProduct, product);
        },1);
    }

    function changeProduct(oldP, newP){
        oldP.classList.add('Inactive');
        oldP.classList.remove('Active');
        setTimeout(() => {
            oldP.classList.remove('Inactive');
            inCd = false;
        }, 1000);
        newP.classList.add('Active');
    }
});

